import { DateTime } from "luxon";

export interface DummyBidEntry {
  id: string;
  user_uuid: string;
  bidder_name: string;
  bidding_amount: number;
  bid_timestamp: number;
  status: "Success" | "Failed";
}

export interface DummyAuctionEvent {
  uuid: string;
  listing_id: string;
  status: "accepted" | "live" | "end";
  event_type: string;
  bidding_type: "ib" | "rp";
  reserve_price: string;
  bidding_increment_amount: string;
  extend_time_at: string;
  start_date_time: string;
  final_end_date: string;
  server_time: number;
  property_dump: {
    asset: {
      name: string;
    };
    sub_asset_type: {
      name: string;
    };
    city: {
      name: string;
    };
    state: {
      name: string;
    };
    bank: {
      name: string;
    };
  };
}

const currentTimeInIst = DateTime.now().setZone("Asia/Kolkata");
const demoStartTime = currentTimeInIst.minus({ minutes: 14 });
const demoEndTime = currentTimeInIst.plus({ minutes: 22 });

export const dummyAuctionEvent: DummyAuctionEvent = {
  uuid: "dummy-auction-event-001",
  listing_id: "AB-26-000079",
  status: "live",
  event_type: "E-Auction",
  bidding_type: "ib",
  reserve_price: "2500000",
  bidding_increment_amount: "50000",
  extend_time_at: "5",
  start_date_time: demoStartTime.toISO() || "",
  final_end_date: String(demoEndTime.toMillis()),
  server_time: currentTimeInIst.toMillis(),
  property_dump: {
    asset: {
      name: "Independent House",
    },
    sub_asset_type: {
      name: "Residential",
    },
    city: {
      name: "Pune",
    },
    state: {
      name: "Maharashtra",
    },
    bank: {
      name: "State Bank of India",
    },
  },
};

export const currentDummyUser = {
  uuid: "bidder-current-user",
  name: "Rahul Sharma",
};

export const dummyBidHistory: DummyBidEntry[] = [
  {
    id: "bid-1",
    user_uuid: "bidder-other-1",
    bidder_name: "Bidder A",
    bidding_amount: 2500000,
    bid_timestamp: currentTimeInIst.minus({ minutes: 12 }).toMillis(),
    status: "Success",
  },
  {
    id: "bid-2",
    user_uuid: currentDummyUser.uuid,
    bidder_name: currentDummyUser.name,
    bidding_amount: 2550000,
    bid_timestamp: currentTimeInIst.minus({ minutes: 9 }).toMillis(),
    status: "Success",
  },
  {
    id: "bid-3",
    user_uuid: "bidder-other-2",
    bidder_name: "Bidder B",
    bidding_amount: 2600000,
    bid_timestamp: currentTimeInIst.minus({ minutes: 6 }).toMillis(),
    status: "Success",
  },
  {
    id: "bid-4",
    user_uuid: currentDummyUser.uuid,
    bidder_name: currentDummyUser.name,
    bidding_amount: 2650000,
    bid_timestamp: currentTimeInIst.minus({ minutes: 4 }).toMillis(),
    status: "Success",
  },
];
